import { BreadcrumbPropsOverrides } from 'Breadcrumbs/types';

import { typography } from '../../styles';

export const getDefaults = ({
  size,
  to,
}: {
  size: 'medium' | 'small';
  to?: string;
}): BreadcrumbPropsOverrides => ({
  Typography: {
    className: typography(size, to),
    color: 'text-text-secondary',
    variant: 'body-short-02',
  },
});
